<template>
    <center>
        <div style="height:90px;"></div>
        <div v-if="idat" class="timelinecontainer">
          <div> 
            <b style="text-align: right">Scroll Right</b>
            <div>
              <b-img src="RightArrowCircle.png" height="100px" width="100px"/>
            </div>
          </div>
            <TimelineEntry v-for="entry in idat.entries"
                v-bind:key="entry.ID"
                v-bind:ID="entry.ID"
                v-bind:header="entry.header"
                v-bind:description="entry.description"
                v-bind:picture="entry.picture"
                v-bind:size="entry.size"
                v-bind:offset="entry.offset"/>
        </div>
    </center>
</template>
<script>
    import { ajaxGet,ajaxPost } from "../../../ajax";
import TimelineEntry from './TimelineEntry'
    import {apiUrl} from "@/main";

export default {
    components: {TimelineEntry },
    data: function() {
        return {
            idat: undefined,
            timelineId: undefined
        }
    },
    created() {
        console.log(JSON.stringify(this.idat));
        this.timelineId = this.$router.history.current.params.timelineId;
            var assignmentFlag = (this.$router.history.current.query.Assignment === null) ? 'assignments' : 'content';
            if(this.timelineId == 'undefined') alert("Not part of assignment.");
            ajaxGet(apiUrl()+"/"+assignmentFlag+"/" + this.timelineId,
            (dat) => {
                //on success dat is called
                if(dat.component == "timeline"){
                    //This is the right component
                    this.idat = dat.data;
                    window.document.title = dat.title;
                    this.isAnswered = dat.answers;
                    //----------------------------------------------------------
                    if(this.$router.history.current.query.Assignment === null && !this.isAnswered){
                        ajaxPost(apiUrl() +"/assignments/" + this.timelineId, {
                        Data: {
                            seen: Date.now()
                        }
                    },
                    (suc) => {
                        console.log("Posted assignment:", suc);
                    },
                    (err) => {
                        console.log("Error :", err)
                    }, localStorage.token);
                    }
                    //----------------------------------------------------------
                }else{
                    //Wrong component type
                    console.error("DATA MISMATCH on api call expected 'TIMELINE' object, got '" + dat.component.toUpperCase() + "' object.");
                }
            },(err) => {
                //There was some error
                console.log(err);
            }, localStorage.token);
    },
    updated: function(){
        this.$nextTick(function() {
            var slider = document.querySelector(".timelinecontainer");
            if(slider){
                let isDown = false;
                let startX;
                let scrollLeft;
                slider.addEventListener("mousedown", e => {
                    isDown = true;
                    slider.classList.add("active");
                    startX = e.pageX - slider.offsetLeft;
                    scrollLeft = slider.scrollLeft;
                });
                slider.addEventListener("mouseleave", () => {
                    isDown = false;
                    slider.classList.remove("active");
                });
                slider.addEventListener("mouseup", () => {
                    isDown = false;
                    slider.classList.remove("active");
                });
                slider.addEventListener("mousemove", e => {
                    if (!isDown) return;
                    e.preventDefault();
                    const x = e.pageX - slider.offsetLeft;
                    const walk = x - startX;
                    slider.scrollLeft = scrollLeft - walk;
                });
            }
        });
    }
}

</script>
<style scoped>
.timelinecontainer {
    position: relative;
    top: 55px;
    width: 800px;
    height: 600px;
    max-width: 800px;
    max-height: 600px;
    overflow: auto;
    display:flex;
    align-items: center;
    
        background: rgb(18,78,26);
        background: linear-gradient(6deg, rgba(18,78,26,1) 0%, rgba(9,121,56,1) 82%, rgba(0,0,0,1) 100%);
}
.timelinecontainer::-webkit-scrollbar{
    display: none;
}

</style>